import React from 'react';
import PropTypes from 'prop-types';

const Cin = ({ fill, ...props }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_5626_41800)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.1973 2.64866C15.4481 2.56519 15.7145 2.5396 15.9766 2.5738C16.2386 2.60801 16.4895 2.70113 16.7105 2.84617C16.9314 2.99121 17.1166 3.1844 17.2522 3.41125C17.3878 3.63811 17.4702 3.89272 17.4933 4.15599L17.5003 4.30999V10.7103L21.9267 11.597C22.2955 11.6705 22.6309 11.8609 22.8831 12.14C23.1352 12.419 23.2908 12.7719 23.3267 13.1463L23.3337 13.312V22.167H24.5003C24.7977 22.1673 25.0837 22.2812 25.2999 22.4853C25.5162 22.6894 25.6463 22.9684 25.6637 23.2653C25.6811 23.5621 25.5845 23.8544 25.3937 24.0825C25.2028 24.3105 24.9321 24.457 24.6368 24.4922L24.5003 24.5003H3.50034C3.20298 24.5 2.91696 24.3861 2.70074 24.182C2.48451 23.9779 2.35439 23.6989 2.33697 23.402C2.31954 23.1052 2.41612 22.8129 2.60698 22.5849C2.79783 22.3568 3.06856 22.2103 3.36383 22.1752L3.50034 22.167H4.667V7.42032C4.667 6.72032 5.08233 6.09499 5.71467 5.81732L5.864 5.76016L15.1973 2.64866ZM15.167 5.11966L7.00033 7.84149V22.167H15.167V5.11966ZM17.5003 13.0915V22.167H21.0003V13.7903L17.5003 13.0915Z"
        fill={fill || '#6B6C7B'}
      />
    </g>
    <defs>
      <clipPath id="clip0_5626_41800">
        <rect width="28" height="28" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

Cin.propTypes = {
  fill: PropTypes.string,
};

export default Cin;
